import { Button } from 'antd';
import sc from 'styled-components';
// import { theme } from '../../../styles/theme';
import { StyledButtonProps } from './type';
import { BUTTON_STYLE } from '../../../styles/buttons';

export const StyledButton = sc(Button) <StyledButtonProps>`
  background-color: ${({ buttonType = 'primary' }) => BUTTON_STYLE[buttonType].backgroundColor};
  color: ${({ buttonType = 'primary' }) => BUTTON_STYLE[buttonType].color};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;s
  padding: ${({ padding }) => padding ?? '0px'} !important;
  box-shadow: none;

  .ant-btn-icon {
    margin-inline-end: 3px !important;
  }

  span, i {
    color: ${({ buttonType = 'primary' }) => BUTTON_STYLE[buttonType].color};
  }

  &:hover {
    background-color: ${({ buttonType = 'primary' }) => BUTTON_STYLE[buttonType].hoverBgColor} !important;

    span, i {
      color: ${({ buttonType = 'primary' }) => BUTTON_STYLE[buttonType].hoverColor} !important;
    }
  }
`;


export const AddMoreBtnContainer = sc.div`
  display: flex;
  justify-content: flex-end;
  margin: 1.5rem 0;

  .ant-btn {
    color: #48bb78;
    font-size: .75rem;
    border: 1px solid #68d391;

    &:hover {
      color: #38a169 !important;
      background-color: #c6f6d5;
    }
  }
`;